module.exports = __webpack_public_path__ + "static/media/van.ccddb0b6.svg";